// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Contact from "./contact.js"
import PaymentMethod from "./payment-method.js"
import Plan from "./plan.js"
import School from "./school.js"
import SchoolClass from "./school-class.js"
import SubscriptionPeriod from "./subscription-period.js"
import User from "./user.js"

const modelClassData = {
  "attributes": {
    "contact_id": {
      "column": {
        "default": null,
        "name": "contact_id",
        "null": false,
        "type": null
      },
      "name": "contact_id",
      "selected_by_default": null,
      "translated": null
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "expired_trial_paywall_shown_at_first_platform_visit": {
      "column": {
        "default": "0",
        "name": "expired_trial_paywall_shown_at_first_platform_visit",
        "null": false,
        "type": "boolean"
      },
      "name": "expired_trial_paywall_shown_at_first_platform_visit",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "payment_method_id": {
      "column": {
        "default": null,
        "name": "payment_method_id",
        "null": true,
        "type": null
      },
      "name": "payment_method_id",
      "selected_by_default": null,
      "translated": null
    },
    "plan_id": {
      "column": {
        "default": null,
        "name": "plan_id",
        "null": false,
        "type": null
      },
      "name": "plan_id",
      "selected_by_default": null,
      "translated": null
    },
    "price": {
      "column": null,
      "name": "price",
      "selected_by_default": null,
      "translated": null
    },
    "state": {
      "column": {
        "default": "inactive",
        "name": "state",
        "null": false,
        "type": "string"
      },
      "name": "state",
      "selected_by_default": null,
      "translated": null
    },
    "subscription_periods_count": {
      "column": {
        "default": "0",
        "name": "subscription_periods_count",
        "null": false,
        "type": "integer"
      },
      "name": "subscription_periods_count",
      "selected_by_default": null,
      "translated": null
    },
    "translated_state": {
      "column": null,
      "name": "translated_state",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": false,
      "translated": null
    },
    "number_of_completed_woofs": {
      "column": null,
      "name": "number_of_completed_woofs",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "Subscription",
  "collectionKey": "subscriptions",
  "collectionName": "subscriptions",
  "i18nKey": "subscription",
  "camelizedLower": "subscription",
  "name": "Subscription",
  "nameDasherized": "subscription",
  "pluralName": "subscriptions",
  "ransackable_associations": [
    {
      "className": "SubscriptionPeriod",
      "collectionName": "subscription_periods",
      "foreignKey": "subscription_id",
      "name": "active_period",
      "macro": "has_one",
      "resource_name": "SubscriptionPeriod",
      "through": null
    },
    {
      "className": "Subscription::Audit",
      "collectionName": "subscription_audits",
      "foreignKey": "subscription_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "SubscriptionAudit",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "Subscription::Audit",
      "collectionName": "subscription_audits",
      "foreignKey": "subscription_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "SubscriptionAudit",
      "through": null
    },
    {
      "className": "InvoiceInfo",
      "collectionName": "invoice_infos",
      "foreignKey": "resource_id",
      "name": "invoice_info",
      "macro": "has_one",
      "resource_name": "InvoiceInfo",
      "through": null
    },
    {
      "className": "SubscriptionPeriod",
      "collectionName": "subscription_periods",
      "foreignKey": "subscription_id",
      "name": "last_period",
      "macro": "has_one",
      "resource_name": "SubscriptionPeriod",
      "through": null
    },
    {
      "className": "PaymentMethod",
      "collectionName": "payment_methods",
      "foreignKey": "payment_method_id",
      "name": "payment_method",
      "macro": "belongs_to",
      "resource_name": "PaymentMethod",
      "through": null
    },
    {
      "className": "Plan",
      "collectionName": "plans",
      "foreignKey": "plan_id",
      "name": "plan",
      "macro": "belongs_to",
      "resource_name": "Plan",
      "through": null
    },
    {
      "className": "School",
      "collectionName": "schools",
      "foreignKey": "contact_id",
      "name": "school",
      "macro": "has_one",
      "resource_name": "School",
      "through": "contact"
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "contact_id",
      "name": "school_class",
      "macro": "has_one",
      "resource_name": "SchoolClass",
      "through": "contact"
    },
    {
      "className": "StripeSubscription",
      "collectionName": "stripe_subscriptions",
      "foreignKey": "stripe_subscription_id",
      "name": "stripe_subscription",
      "macro": "belongs_to",
      "resource_name": "StripeSubscription",
      "through": null
    },
    {
      "className": "SubscriptionPeriod",
      "collectionName": "subscription_periods",
      "foreignKey": "subscription_id",
      "name": "subscription_periods",
      "macro": "has_many",
      "resource_name": "SubscriptionPeriod",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "contact_id",
      "name": "user",
      "macro": "has_one",
      "resource_name": "User",
      "through": "contact"
    }
  ],
  "ransackable_attributes": [
    {
      "name": "contact_id",
      "column": {
        "default": null,
        "name": "contact_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "expired_trial_paywall_shown_at_first_platform_visit",
      "column": {
        "default": "0",
        "name": "expired_trial_paywall_shown_at_first_platform_visit",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "payment_method_id",
      "column": {
        "default": null,
        "name": "payment_method_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "plan_id",
      "column": {
        "default": null,
        "name": "plan_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "price_cents",
      "column": {
        "default": "0",
        "name": "price_cents",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "price_currency",
      "column": {
        "default": "USD",
        "name": "price_currency",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "state",
      "column": {
        "default": "inactive",
        "name": "state",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "stripe_subscription_id",
      "column": {
        "default": null,
        "name": "stripe_subscription_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "subscription_periods_count",
      "column": {
        "default": "0",
        "name": "subscription_periods_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "select_number_of_completed_woofs"
    },
    {
      "name": "with_active_period"
    },
    {
      "name": "without_active_period"
    }
  ],
  "relationships": [
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "SubscriptionPeriod",
      "collectionName": "subscription_periods",
      "foreignKey": "subscription_id",
      "name": "last_period",
      "macro": "has_one",
      "resource_name": "SubscriptionPeriod",
      "through": null
    },
    {
      "className": "PaymentMethod",
      "collectionName": "payment_methods",
      "foreignKey": "payment_method_id",
      "name": "payment_method",
      "macro": "belongs_to",
      "resource_name": "PaymentMethod",
      "through": null
    },
    {
      "className": "Plan",
      "collectionName": "plans",
      "foreignKey": "plan_id",
      "name": "plan",
      "macro": "belongs_to",
      "resource_name": "Plan",
      "through": null
    },
    {
      "className": "School",
      "collectionName": "schools",
      "foreignKey": "contact_id",
      "name": "school",
      "macro": "has_one",
      "resource_name": "School",
      "through": "contact"
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "contact_id",
      "name": "school_class",
      "macro": "has_one",
      "resource_name": "SchoolClass",
      "through": "contact"
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "contact_id",
      "name": "user",
      "macro": "has_one",
      "resource_name": "User",
      "through": "contact"
    }
  ],
  "paramKey": "subscription",
  "primaryKey": "id"
}

/** Frontend model for Subscription. */
export default class Subscription extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {any} */
  contactId() {
    return this.readAttributeUnderscore("contact_id")
  }

  /** @returns {boolean} */
  hasContactId() {
    const value = this.contactId()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  expiredTrialPaywallShownAtFirstPlatformVisit() {
    return this.readAttributeUnderscore("expired_trial_paywall_shown_at_first_platform_visit")
  }

  /** @returns {boolean} */
  hasExpiredTrialPaywallShownAtFirstPlatformVisit() {
    const value = this.expiredTrialPaywallShownAtFirstPlatformVisit()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {any | null} */
  paymentMethodId() {
    return this.readAttributeUnderscore("payment_method_id")
  }

  /** @returns {boolean} */
  hasPaymentMethodId() {
    const value = this.paymentMethodId()

    return this._isPresent(value)
  }

  /** @returns {any} */
  planId() {
    return this.readAttributeUnderscore("plan_id")
  }

  /** @returns {boolean} */
  hasPlanId() {
    const value = this.planId()

    return this._isPresent(value)
  }

  /** @returns {any} */
  price() {
    return this.readAttributeUnderscore("price")
  }

  /** @returns {boolean} */
  hasPrice() {
    const value = this.price()

    return this._isPresent(value)
  }

  /** @returns {string} */
  state() {
    return this.readAttributeUnderscore("state")
  }

  /** @returns {boolean} */
  hasState() {
    const value = this.state()

    return this._isPresent(value)
  }

  /** @returns {number} */
  subscriptionPeriodsCount() {
    return this.readAttributeUnderscore("subscription_periods_count")
  }

  /** @returns {boolean} */
  hasSubscriptionPeriodsCount() {
    const value = this.subscriptionPeriodsCount()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedState() {
    return this.readAttributeUnderscore("translated_state")
  }

  /** @returns {boolean} */
  hasTranslatedState() {
    const value = this.translatedState()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {any} */
  numberOfCompletedWoofs() {
    return this.readAttributeUnderscore("number_of_completed_woofs")
  }

  /** @returns {boolean} */
  hasNumberOfCompletedWoofs() {
    const value = this.numberOfCompletedWoofs()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static customerPortalUrl(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "customer_portal_url",
        collectionName: "subscriptions",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static hasPro(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "has_pro",
        collectionName: "subscriptions",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static startProUserTrial(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "start_pro_user_trial",
        collectionName: "subscriptions",
        type: "collection"
      },
      commandArgs
    ))
  }

  /** @returns {import("./contact.js").default | null} */
  contact() {
    return this._readBelongsToReflection({modelClass: Contact, reflectionName: "contact"})
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  loadContact() {
    if (!("contactId" in this)) throw new Error("Foreign key method wasn't defined: contactId")

    const id = this.contactId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "contact",
        model: this,
        modelClass: Contact
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  ensureContactLoaded() {
    return this.ensureAssociationLoaded("contact")
  }

  /** @returns {import("./subscription-period.js").default | null} */
  lastPeriod() {
    return this._readHasOneReflection({modelClass: SubscriptionPeriod, reflectionName: "last_period"})
  }

  /** @returns {Promise<import("./subscription-period.js").default | null>} */
  loadLastPeriod() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["subscription_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "last_period",
        model: this,
        modelClass: SubscriptionPeriod
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./subscription-period.js").default | null>} */
  ensureLastPeriodLoaded() {
    return this.ensureAssociationLoaded("last_period")
  }

  /** @returns {import("./payment-method.js").default | null} */
  paymentMethod() {
    return this._readBelongsToReflection({modelClass: PaymentMethod, reflectionName: "payment_method"})
  }

  /** @returns {Promise<import("./payment-method.js").default | null>} */
  loadPaymentMethod() {
    if (!("paymentMethodId" in this)) throw new Error("Foreign key method wasn't defined: paymentMethodId")

    const id = this.paymentMethodId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "payment_method",
        model: this,
        modelClass: PaymentMethod
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./payment-method.js").default | null>} */
  ensurePaymentMethodLoaded() {
    return this.ensureAssociationLoaded("payment_method")
  }

  /** @returns {import("./plan.js").default | null} */
  plan() {
    return this._readBelongsToReflection({modelClass: Plan, reflectionName: "plan"})
  }

  /** @returns {Promise<import("./plan.js").default | null>} */
  loadPlan() {
    if (!("planId" in this)) throw new Error("Foreign key method wasn't defined: planId")

    const id = this.planId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "plan",
        model: this,
        modelClass: Plan
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./plan.js").default | null>} */
  ensurePlanLoaded() {
    return this.ensureAssociationLoaded("plan")
  }

  /** @returns {import("./school.js").default | null} */
  school() {
    return this._readHasOneReflection({modelClass: School, reflectionName: "school"})
  }

  /** @returns {Promise<import("./school.js").default | null>} */
  loadSchool() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()

    return this._loadHasOneReflection(
      {
        reflectionName: "school",
        model: this,
        modelClass: School
      },
      {
        params: {
          through: {
            model: "Subscription",
            id,
            reflection: "school"
          }
        }
      }
    )
  }

  /** @returns {Promise<import("./school.js").default | null>} */
  ensureSchoolLoaded() {
    return this.ensureAssociationLoaded("school")
  }

  /** @returns {import("./school-class.js").default | null} */
  schoolClass() {
    return this._readHasOneReflection({modelClass: SchoolClass, reflectionName: "school_class"})
  }

  /** @returns {Promise<import("./school-class.js").default | null>} */
  loadSchoolClass() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()

    return this._loadHasOneReflection(
      {
        reflectionName: "school_class",
        model: this,
        modelClass: SchoolClass
      },
      {
        params: {
          through: {
            model: "Subscription",
            id,
            reflection: "school_class"
          }
        }
      }
    )
  }

  /** @returns {Promise<import("./school-class.js").default | null>} */
  ensureSchoolClassLoaded() {
    return this.ensureAssociationLoaded("school_class")
  }

  /** @returns {import("./user.js").default | null} */
  user() {
    return this._readHasOneReflection({modelClass: User, reflectionName: "user"})
  }

  /** @returns {Promise<import("./user.js").default | null>} */
  loadUser() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()

    return this._loadHasOneReflection(
      {
        reflectionName: "user",
        model: this,
        modelClass: User
      },
      {
        params: {
          through: {
            model: "Subscription",
            id,
            reflection: "user"
          }
        }
      }
    )
  }

  /** @returns {Promise<import("./user.js").default | null>} */
  ensureUserLoaded() {
    return this.ensureAssociationLoaded("user")
  }
}
